export type SignedDocumentKind = "signed" | "attachment";

/**
 * Builds the upload body for POST /contract/:id/signed-document.
 *
 * The endpoint reads files via FilesInterceptor('documents'), so the field name
 * has to be exactly "documents" - a mismatch uploads nothing and the request
 * fails with "At least one signed document file is required". Both callers
 * (creating a pre-signed contract, and attaching from the contracts list) go
 * through here so they cannot drift apart again.
 */
export const buildSignedDocumentFormData = (
  files: File[],
  signedDate: Date | null,
  kind: SignedDocumentKind
): FormData => {
  const formData = new FormData();

  files.forEach((file) => formData.append("documents", file));

  if (signedDate) {
    formData.append("signedDate", signedDate.toISOString());
  }

  formData.append("kind", kind);

  return formData;
};

/**
 * The global axios interceptor forces application/json, which makes axios
 * stringify FormData and drop the files. Every upload needs both overrides.
 */
export const multipartRequestConfig = {
  headers: { "Content-Type": "multipart/form-data" },
  transformRequest: (formData: any) => formData,
};
